export const rolesRoutesMap = {
  gestion: {
    path: '/roles/gestion',
    name: 'Gestión de roles',
  },
  nuevo: {
    path: '/roles/nuevo',
    name: 'Nuevo Rol',
  },
  modificar: {
    path: `/roles/modificar`,
    name: 'Modificar Rol',
  },
}
